/* eslint-disable @repo/internal/react/no-class-components */
import React from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
const CROSS_FLOW_CHANNEL = 'crossFlow';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    const analyticsEvent = this.props.createAnalyticsEvent({
      action: 'handled',
      actionSubject: 'error',
      actionSubjectId: 'surfaceErrorBoundary',
      attributes: {
        error: error,
        errorInfo
      }
    });
    analyticsEvent.fire(CROSS_FLOW_CHANNEL);
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallback ? /*#__PURE__*/React.createElement(React.Fragment, null, this.props.fallback) : null;
    }
    return this.props.children;
  }
}
export default withAnalyticsEvents()(ErrorBoundary);